import { QueryClient } from '@tanstack/react-query';
import { httpBatchLink, loggerLink } from '@trpc/client';
import superjson from 'superjson';

import { apiUrl } from '@/lib/api-url';

import { trpc } from './client';

const links = [
  loggerLink({
    enabled: (op) => import.meta.env.DEV || (op.direction === 'down' && op.result instanceof Error),
  }),
  httpBatchLink({
    url: apiUrl('/trpc'),
    transformer: superjson,
    methodOverride: 'POST',
    fetch(input, init) {
      return fetch(input, { ...init, credentials: 'include' });
    },
  }),
];

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
      retry: 1,
    },
  },
});

export const trpcReactClient = trpc.createClient({ links });
